import api from 'utils/api';

export const fetchReferrerPatientsApi = (page = 1) =>
	api.get(`/referrer/patients?page=${page}&limit=25`);

export const fetchReferrerPendingApi = () =>
	api.get('/referrer/patients/pending');
